import { jsx } from "panel";
import { WarningHeroEl } from "common/widgets/warning-hero";
import { WarningHeroTheme } from "common/widgets/warning-hero/constants";
import { WorkspaceStatus } from "common/widgets/workspace-global-only-banner/types";
export function template() {
  const { globalProjectWorkspace, workspaceStatus } = this.state;
  return /* @__PURE__ */ jsx("div", {
    sel: ".workspace-global-only-banner"
  }, workspaceStatus === WorkspaceStatus.NO_WORKSPACE_ACCESS ? /* @__PURE__ */ jsx(WarningHeroEl, {
    attrs: {
      theme: WarningHeroTheme.Default,
      "header-text": `Only Available in the Global Data View`,
      "body-text": globalProjectWorkspace ? `Mixpanel ${this.helpers.getAppName()} ${this.helpers.getIsOrAre()} only available from ${globalProjectWorkspace.name} (Global Data View)` : `Mixpanel ${this.helpers.getAppName()} ${this.helpers.getIsOrAre()} only available from the Global Data View`
    }
  }, !globalProjectWorkspace ? /* @__PURE__ */ jsx("div", {
    sel: ".more"
  }, "You are not a member of the Global Data View and it is private.", /* @__PURE__ */ jsx("div", {
    sel: ".more"
  }, "Contact your project Admin or Owner for access."), /* @__PURE__ */ jsx("div", {
    sel: ".cta-links"
  }, /* @__PURE__ */ jsx("a", {
    sel: ".btn-link",
    attrs: {
      href: this.helpers.getAppUrl({
        appPath: `insights`,
        projectId: this.helpers.getProjectId(),
        workspaceId: this.attr(`workspace-id`)
      })
    }
  }, "Go to Insights in this Data View"))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".more"
  }, "You are not a member of the Global Data View but it can be joined using the Data View Library."), /* @__PURE__ */ jsx("div", {
    sel: ".cta-links"
  }, /* @__PURE__ */ jsx("a", {
    attrs: {
      href: this.helpers.getAppUrl({
        appPath: `insights`,
        projectId: this.helpers.getProjectId(),
        workspaceId: this.attr(`workspace-id`)
      })
    }
  }, "Go to Insights in this Data View"), /* @__PURE__ */ jsx("a", {
    sel: ".btn-link",
    attrs: {
      href: this.helpers.getAppUrl({ appPath: `views`, projectId: this.helpers.getProjectId() })
    }
  }, "Go to Data View Library")))) : /* @__PURE__ */ jsx(WarningHeroEl, {
    attrs: {
      theme: WarningHeroTheme.Default,
      "header-text": `Only Available in the Global Data View`,
      "body-text": `Mixpanel ${this.helpers.getAppName()} ${this.helpers.getIsOrAre()} only available from ${globalProjectWorkspace.name} (Global Data View)`
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".cta-links"
  }, /* @__PURE__ */ jsx("a", {
    attrs: {
      href: this.helpers.getAppUrl({
        appPath: `insights`,
        projectId: this.helpers.getProjectId(),
        workspaceId: this.attr(`workspace-id`)
      })
    }
  }, "Go to Insights in this Data View"), /* @__PURE__ */ jsx("a", {
    sel: ".btn-link",
    attrs: {
      href: this.helpers.getAppUrl({
        appPath: this.helpers.getAppPath(),
        projectId: this.helpers.getProjectId(),
        workspaceId: globalProjectWorkspace.id
      })
    }
  }, "View in Global Data View"))));
}
